import React, { useState, useEffect } from "react";
import "../../assets/styles/local/WorkflowAutomation.css";
import { useParams } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import WorkFlowCard from "./WorkFlowCard";
import { ENUM_ACTION, ENUM_CONDITION } from "./AuotmationEnum";
import ConditionWorkflow from "./ConditionWorkflow";
import ActionWorkflow from "./ActionWorkflow";
import ConditionTypeSelection from "./ConditionTypeSelection";
import { useDispatch, useSelector } from "react-redux";
import {
  FetchTriggers,
  FetchRules,
  AddNewCondition,
  FetchActions,
  AddNewAction,
  FetchQuestions,
  FetchTaskTypes,
  FetchTaskStatus,
  FetchTaskList,
} from "../../redux/actions/workflowAutomationActions";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const WorkflowDesigner = (props) => {
  const emptyWorkflowObj = {
    type: "",
    triggerValue: "",
    triggerId: "",
    rule: "",
    ruleId: "",
    ruleValue: "",
    moduleId: "",
    moduleName: "",
    actionTitle: "",
    actionName: "",
    complete: false,
    workFlowId: "",
    nodeName: "",
    conditionType: "",
  };

  const dispatch = useDispatch();
  const { id } = useParams();

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Workflow-Automation-Add-Edit").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  useEffect(() => {
    dispatch(FetchTriggers());
    dispatch(FetchRules());
    dispatch(FetchActions());
    dispatch(FetchTaskTypes());
    dispatch(FetchQuestions(props.formData.formId));
    dispatch(FetchTaskStatus());
    dispatch(FetchTaskList());
  }, []);

  useEffect(() => {
    if (id && props.formData) {
      let workflowArrObject = [];
      if (props.formData.workflowcondition) {
        let workflowConditionArrObject = props.formData.workflowcondition.map(
          (o) => {
            return {
              type: ENUM_CONDITION,
              triggerValue: o.triggername,
              rule: o.rulename,
              ruleValue: o.value,
              nodeName: o.nodeName,
              complete: true,
              workFlowId: id,
              conditionType: o.conditionType ? o.conditionType : "",
            };
          }
        );

        workflowArrObject = workflowConditionArrObject;
      }

      if (props.formData.workflowaction) {
        let workflowActionArrObject = props.formData.workflowaction.map((o) => {
          return {
            type: ENUM_ACTION,
            moduleName: o.modulename,
            actionTitle: o.actionTitle,
            actionName: o.actionname,
            nodeName: o.nodeName,
            complete: true,
            workFlowId: id,
          };
        });

        workflowArrObject = [...workflowArrObject, ...workflowActionArrObject];
      }

      if (workflowArrObject.length > 0) {
        workflowArrObject.sort((a, b) => +a.nodeName - +b.nodeName);
        setWorkFlowData(workflowArrObject);
        setShowWorkflowActions(false);
      }
    }
  }, [id]);

  const [showWorkflowActions, setShowWorkflowActions] = useState(true);

  const [workFlowData, setWorkFlowData] = useState([emptyWorkflowObj]);

  const [workflowCommandType, setWorkflowCommandType] = useState("");
  const [conditionalAction, setConditionAction] = useState(false);

  const addNewWorkFlowCard = () => {
    if (workFlowData[workFlowData.length - 1].type !== "") {
      let workflowArr = [...workFlowData, emptyWorkflowObj];
      setWorkFlowData(workflowArr);
      setShowWorkflowActions(true);
      setWorkflowCommandType("");
    }
  };

  const handleApplyCondition = (data) => {
    let _workflowdata = {
      ...emptyWorkflowObj,
      type: ENUM_CONDITION,
      triggerId: data.triggerId,
      triggerValue: data.triggerValue,
      ruleId: data.ruleId,
      rule: data.rule,
      ruleValue: data.value,
      complete: true,
      conditionType: workFlowData[workFlowData.length - 1].conditionType,
      questionId: data.questionId,
    };

    AddNewCondition({
      workFlowId: props.formData.workFlowId,
      triggerId: _workflowdata.triggerId,
      ruleId: data.ruleId,
      value: _workflowdata.ruleValue,
      nodeName: workFlowData.length,
      type: _workflowdata.type,
      conditionType: _workflowdata.conditionType,
      questionId: data.questionId,
    })
      .then((res) => {
        addWorkflowObject(_workflowdata);
        setShowWorkflowActions(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleApplyAction = (data) => {
    let _workflowdata = {
      ...emptyWorkflowObj,
      type: ENUM_ACTION,
      moduleId: data.moduleId,
      moduleName: data.moduleName,
      actionTitle: data.actionTitle,
      actionName: data.actionName,
      complete: true,
    };

    AddNewAction({
      workFlowId: props.formData.workFlowId,
      moduleId: _workflowdata.moduleId,
      actionId: data.actionId,
      actionTitle: data.actionTitle,
      actionDescription: data.actionDescription,
      startdate: data.startdate,
      enddate: data.enddate,
      nodeName: workFlowData.length,
      type: _workflowdata.type,
      workFlowactionassignee: data.workFlowactionassignee,
      startDateCount: data.startDateCount,
      endDateCount: data.endDateCount,
      taskId: data.taskId,
      taskstatusId: data.taskStatus,
      workflowChecklist: data.workflowChecklist,
    }).then((res) => {
      addWorkflowObject(_workflowdata);
      setShowWorkflowActions(false);
    });
  };

  const addWorkflowObject = (data) => {
    if (workFlowData.length === 1 && workFlowData[0].workFlowId === "") {
      setWorkFlowData([data]);
    } else {
      let workflowArr = [...workFlowData];
      workflowArr[workflowArr.length - 1] = data;
      setWorkFlowData(workflowArr);
    }
  };

  const checkLastTypeOfWorkflow = () => {
    let lastIndex = workFlowData.length > 1 ? workFlowData.length - 2 : 0;
    let lastAction = workFlowData[lastIndex];

    if (lastAction.type === ENUM_CONDITION) {
      setConditionAction(true);
    }
  };

  const applyConditionType = (type) => {
    if (workFlowData.length > 1) {
      let _workflowData = [...workFlowData];
      _workflowData[_workflowData.length - 1].conditionType = type;
      setWorkFlowData(_workflowData);
    }
  };

  return (
    <div className="add-edit-workflow-body p-5">
      <Row>
        <Col xl={6}>
          <WorkFlowCard
            workFlowData={workFlowData}
            formData={props.formData}
            addNewWorkFlowCard={addNewWorkFlowCard}
          />
        </Col>
        <Col xl={6}>
          {showWorkflowActions && (
            <>
              {/* Automation Length  */}
              <div className="action-count d-flex justify-content-center">
                <strong>{workFlowData.length}</strong>
              </div>

              {conditionalAction && (
                <ConditionTypeSelection
                  close={setConditionAction}
                  apply={applyConditionType}
                />
              )}

              {/* Automation Actions  */}
              <div
                className="d-flex gap-5 width-35-vw"
                style={{ marginTop: "50px" }}
              >
                <div
                  className={`workflow-design-action ${
                    workflowCommandType === ENUM_CONDITION ? "selected" : ""
                  }`}
                  onClick={() => {
                    if (workflowCommandType === "") {
                      setWorkflowCommandType(ENUM_CONDITION);
                      checkLastTypeOfWorkflow();
                    }
                  }}
                >
                  {ENUM_CONDITION}
                </div>
                <div
                  className={`workflow-design-action ${
                    workflowCommandType === ENUM_ACTION ? "selected" : ""
                  }`}
                  onClick={() => {
                    if (workflowCommandType === "") {
                      setWorkflowCommandType(ENUM_ACTION);
                    }
                  }}
                >
                  {ENUM_ACTION}
                </div>
              </div>

              {/* Automation Form  */}
              <div className="mt-4">
                {!conditionalAction &&
                  workflowCommandType === ENUM_CONDITION && (
                    <ConditionWorkflow
                      applyCondition={handleApplyCondition}
                      formId={props.formData.formId}
                    />
                  )}

                {workflowCommandType === ENUM_ACTION && (
                  <ActionWorkflow applyAction={handleApplyAction} />
                )}
              </div>
            </>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default WorkflowDesigner;
